module.exports = __webpack_public_path__ + "img/planner.25d8058f.png";